// extracted by mini-css-extract-plugin
export default {"Box":"potentially-dirty-module__Box--tM_Ae","PotentiallyDirty":"potentially-dirty-module__PotentiallyDirty--dAl1a","hasChildren":"potentially-dirty-module__hasChildren--DkObX"};